import { observable, action, runInAction, computed } from 'mobx';

import apiStore from './api-store';
import songsStore from './songs-store';
import artistStore from './artist-store';
import userStore from './user-store';
import config from 'client/shared/config';

const { apiBase } = config;
const heroArtistRoute = `${apiBase}/bff/members/hero-artist`;
const artistSummaryRoute = `${apiBase}/bff/members/artist-summary/:artistId`;

const DATA_STATES = {
    IDLE: 'idle',
    LOADING: 'loading',
    SUCCESS: 'success',
    ERROR: 'error',
    CLOSE: 'close'
};

class MemberStore {
    @observable heroArtist = null;
    @observable artistSummary = null;
    @observable currentPlaylist = [];
    @observable relatedArtists = [];
    @observable _dataState = DATA_STATES.IDLE;
    @observable _dataModalState = DATA_STATES.IDLE;

    @action
    setCurrentPlaylist (playlist) {
        console.log('[MemberStore] setCurrentPlaylist ===========================', playlist);
        this.currentPlaylist = playlist;
    }

    @action
    async fetchHeroArtist () {
        this._dataState = DATA_STATES.LOADING;

        try {
            const route = heroArtistRoute;
            const { data } = await apiStore.ax.get(route);

            runInAction(() => {
                this.heroArtist = {
                    ...data,
                    id: data._id
                };

                this._dataState = DATA_STATES.SUCCESS;
            });
        } catch (error) {
            runInAction(() => {
                console.error('Error fetching hero artist:', error);
                this._dataState = DATA_STATES.ERROR;
            });
        }
    }

    @action
    async fetchArtistSummary (artistId) {
        this._dataState = DATA_STATES.LOADING;

        try {
            const route = artistSummaryRoute.replace(':artistId', artistId);
            const { data } = await apiStore.ax.get(route);

            runInAction(() => {
                this.artistSummary = {
                    ...data,
                    id: data._id
                };

                songsStore.songs = data.songs;
                artistStore.artists = [data];

                this._dataState = DATA_STATES.SUCCESS;
            });
        } catch (error) {
            runInAction(() => {
                console.error('Error fetching artist summary:', error);
                this._dataState = DATA_STATES.ERROR;
            });
        }
    }

    @action
    resetSubscribeModalState () {
        this._dataModalState = DATA_STATES.IDLE;
        this.relatedArtists = [];
    }

    @action
    async subscribeToArtist ({ artistID, paymentMethodID }) {
        this._dataModalState = DATA_STATES.LOADING;

        try {

            const member = userStore.getLoggedInUser();
            const { relatedArtists } = await apiStore.save({
                route: config.getRoute('subscription'),
                payload: {
                    memberID: member.id,
                    paymentMethodID, artistID
                }
            });

            runInAction(() => {
                this._dataModalState = DATA_STATES.SUCCESS;
                this.relatedArtists = relatedArtists || [];
            });
        } catch (error) {
            runInAction(() => {
                console.error('Error subscribing to artist:', error);
                this._dataModalState = DATA_STATES.ERROR;
            });
        }
    }

    @computed
    get isIdle() {
        return this._dataState === DATA_STATES.IDLE;
    }

    @computed
    get isLoading() {
        return this._dataState === DATA_STATES.LOADING;
    }

    @computed
    get isSuccess() {
        return this._dataState === DATA_STATES.SUCCESS;
    }

    @computed
    get isError() {
        return this._dataState === DATA_STATES.ERROR;
    }

    @computed
    get isModalDataIdle() {
        return this._dataModalState === DATA_STATES.IDLE;
    }

    @computed
    get isModalDataLoading() {
        return this._dataModalState === DATA_STATES.LOADING;
    }

    @computed
    get isModalDataSuccess() {
        return this._dataModalState === DATA_STATES.SUCCESS;
    }

    @computed
    get isModalDataClose() {
        return this._dataModalState === DATA_STATES.CLOSE;
    }

    @computed
    get isModalDataError() {
        return this._dataModalState === DATA_STATES.ERROR;
    }
}

const membersBFFStore = new MemberStore();
export default membersBFFStore;
